import { render, staticRenderFns } from "./demandCustomize.vue?vue&type=template&id=15a26a14&scoped=true&"
import script from "./demandCustomize.vue?vue&type=script&lang=js&"
export * from "./demandCustomize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a26a14",
  null
  
)

export default component.exports